import React, { useEffect } from "react";
import { Slide, toast, ToastContainer } from "react-toastify";
import useAdminDataStore, { selectCurrentGroupData } from "../../../store/adminData/adminData";
import ChantButton from "../../../CommonComponents/ChantButton/ChantButton";
import { useNavigate } from "react-router-dom";
import "./News.css";

const News = () => {
  const groupData = useAdminDataStore(selectCurrentGroupData);

  const navigate = useNavigate();

  useEffect(() => {
    if (groupData?.registrationLink?.startsWith("https://chant.page.link/")) {
      toast(
        <div>
          <p style={{ marginBottom: "4px", fontSize: "14px" }}>
            Required: Please update the QR / Registration link in
            Members/Onboard/Option #4. The current code will no longer work for
            onboarding.
          </p>
          <ChantButton
            onClick={() => {
              toast.dismiss();
              navigate("/admin/members/onboard");
            }}
          >
            Continue
          </ChantButton>
        </div>,
        {
          position: "top-center",
          autoClose: false,
          className: "wide-toast",
          closeButton: ({ closeToast }) => (
            <span
              onClick={closeToast}
              style={{
                // color: "black",
                padding: "6px",
                cursor: "pointer",
              }}
            >
              ✕
            </span>
          ),
        }
      );
    } else {
      toast.dismiss();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupData?.id]);

  return (
    <ToastContainer
      position="top-center"
      closeButton
      autoClose={3000}
      newestOnTop={true}
      transition={Slide}
    />
  );
};

export default News;
